import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './nav.scss';
import BBYLogo from '../logo';
import OutsideClick from './OutsideClick';
import { useAppContext } from '../../context';
import useCheckMobileScreen from '../../hooks/useCheckMobileScreen';
import Notification from '../notification';

function TabBox({ to, icon, lable, isMobile }) {
    const { tabHandler } = useAppContext();
    const navigate = useNavigate();
    const clickHandler = (to) => {
        const tabState = to.replace("/","").split("-")[0];
        tabHandler(tabState);
        navigate(to)
    }
    return (
        <Link to={to} className={isMobile ? "" : "active-tab-desktop"} onClick={() => clickHandler(to)}>
            <div className="alignImgText">
                <img src={icon} alt={lable} title={lable} className="insight-pop-up-p-xy" />
                <p>{lable}</p>
            </div>
        </Link>
    )
}

function MainHeader() {
    const { insightTab,tabHandler, isMobile: isMB } = useAppContext();
    const location = useLocation();
    const { pathname } = location;
    const [isMobile, setIsMobile] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [refContWidth, setRefContWidth] = useState(0);
    const [arrowState, setArrowState] = useState(false);
    const [winResize, setWinResize] = useState(false);
    const [isInsight, setIsInsight] = useState(false);
    const subMenuRef = useRef();
    const mainMenuRef = useRef();
    const hammberRef = useRef();
    const refContainer = useRef();
    const spanRef = useRef();
    const subMenuLiRef = useRef();
    const mainMenuRefMobile = useRef();
    const navigate = useNavigate();


    const handleClickUl = (e) => {
        const ul = e.target.closest('div').nextElementSibling;
        ul.classList.toggle("hidden");
        setIsOpen(!isOpen);
        if (!isMB) {
            setArrowState(!arrowState)
        }
    }


    useEffect(() => {
        const handleResize = () => {
            setWinResize(true)
            setWindowWidth(window.innerWidth);
            if (window.innerWidth > 768) {
                setIsMobile(false);
            }
        };
        window.addEventListener("resize", handleResize);
        setRefContWidth(refContainer?.current?.offsetWidth);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [windowWidth, refContWidth]);

    const activeClass = isMobile => isMobile ? 'active' : 'active active_desktop';
    const clickHandler = (url, hasSubMenu) => {
        setIsOpen(false);
        if (hasSubMenu) {
            subMenuRef?.current?.classList.toggle('hidden');
            setArrowState(false)
        } else if (!hasSubMenu) {
            subMenuRef?.current?.classList.add('hidden');
            setArrowState(false)
        }
        if (isMobile) {
            mainMenuRef?.current?.classList.toggle('hidden');
            hammberRef?.current?.classList.remove('active');
            setIsMobile(!isMobile)
        }
    }
    const mobileMenuHandler = () => {
        mainMenuRefMobile?.current?.classList.remove('d_none')
        setIsMobile(!isMobile)
        setIsOpen(false)

    }
    useEffect(() => {

        if (!isMobile) {
            mainMenuRefMobile?.current?.classList.remove('mobileOpenmenu')
            mainMenuRefMobile?.current?.classList.add('mobileCloseMenu')
        }
        else {
            mainMenuRefMobile?.current?.classList.remove('mobileCloseMenu')
            if(isOpen){
             
                mainMenuRefMobile?.current?.classList.add('mobileOpenmenu', 'mobileOpenSubmenu')
            }else {
               
                mainMenuRefMobile?.current?.classList.add('mobileOpenmenu')
                mainMenuRefMobile?.current?.classList.remove('mobileOpenSubmenu')
            }
            
        }
    }, [mainMenuRef, isMobile, isOpen])

    useEffect(() => {
        if(arrowState){
            handleOutsideClick();
            return () => {
                handleOutsideClick();
            }
        }
    }, [pathname])
   
    useEffect(() => {
        if (arrowState) {
            setWinResize(false)
        }
    }, [arrowState])
  
    const tabs = ['success-story','intel-ideas','whats-news'];
    const currentTab = pathname.split("/")[1];
    useEffect(() => {
        setIsInsight(false)
        if (currentTab === 'insight' || tabs.includes(currentTab)) {
            setIsInsight(true)
        }
        if(pathname === '/success-story'){
            tabHandler('success');
        }
        
    }, [pathname])

    const handleOutsideClick = React.useCallback(() => {
        setIsOpen(false);
        if (isMobile) {
            mainMenuRef?.current?.classList.toggle('hidden');
            hammberRef?.current?.classList.remove('active');
            setIsMobile(!isMobile)
        } else {
            subMenuRef?.current?.classList.add('hidden');
            setArrowState(false)
        }
    }, [isMobile, arrowState])

    const handleClickOnNavArea = React.useCallback(() => {
        if (arrowState) {
            return handleOutsideClick();
        }
        return false;
    }, [arrowState, isMobile]);
    
   
    const activeStateClass = (tab=null) => {
        return isInsight && tabs.includes(tab);
    }
    const navFunction = () => {
        const tabClickHandler = (tab) => {
            navigate(tab);
        }
        return (
            <>
                <ul ref={isMB ? mainMenuRefMobile : mainMenuRef} className={`${isMB ? 'nav-links-mobile d_none' : 'nav-links'}`}>
                    <li id="item-audience" className={`menu-item ${pathname === '/audience' ? 'active' : ''}`}>
                        <Link onClick={() => clickHandler("/audience", false)} to="/audience" id='nav-audience' className={`nav-list ${pathname === 'audience' ? 'active' : ''}`}>Audience</Link>
                    </li>
                    <li id="item-solutions" className={`menu-item  ${pathname === '/solutions' ? 'active' : ''}`}>
                        <Link onClick={() => clickHandler("/solutions", false)} to="/solutions" id='nav-solutions' className={`nav-list ${pathname === 'solutions' ? 'active' : ''}`}>Solutions</Link>
                    </li>

                    <li id="nav-insight" className={`nav-list mainLi ${isInsight ? 'active' : ''}`}>
                       
                        <div id={!isMB ? 'arrowParent' : ''}>
                            <Link onClick={handleClickUl} to="#" id="nav-insight-link" className={`arrowAlign nav-list ${isInsight ? 'active' : ''}`}>Insight
                            </Link>
                            <span ref={spanRef} className={`mainArrow ${arrowState || isOpen ? 'openSubMenu' : 'closeSubMenu'} down-arrow whiteColor ${isInsight ? 'arrowActive' : ''}`} onClick={handleClickUl} ></span>
                        </div>

                        <ul ref={subMenuRef} className={`dropdown-list  ${isMB ?  isOpen ? 'mob-open-submenu' : 'mob-close-subMenu hidden' : !isMobile ? isOpen ? 'openmenu' : 'closeMenu' : 'hidden'}`} style={{
                            width: windowWidth < 1280 ? refContWidth - 74 : refContWidth + 5,
                            left: windowWidth < 1280 ? -refContWidth + 535 : -refContWidth + 455,

                        }}>
                            <li ref={subMenuLiRef}
                                onClick={() => {clickHandler("success", true);tabClickHandler('/success-story')}}
                                className={`subMenuLi ${insightTab === 'success' && activeStateClass('success-story') ? activeClass(isMobile) : ''}`}
                            >
                                <div>
                                    <TabBox
                                        to="/success-story"
                                        icon={'/images/navigation/navigation_success-stories_icon.svg'}
                                        lable={'Success Stories'}
                                        isMobile={isMobile}
                                    />
                                </div>
                            </li>
                            <li
                                onClick={() => {clickHandler("intel", true);tabClickHandler('/intel-ideas');}}
                                className={`subMenuLi ${insightTab === 'intel' && activeStateClass('intel-ideas') ? activeClass(isMobile) : ''}`}>
                                <div>
                                    <TabBox
                                        to="/intel-ideas"
                                        icon={'/images/navigation/navigation_intel-ideas_icon.svg'}
                                        lable={'Intel & Ideas'}
                                        isMobile={isMobile}
                                    />
                                </div>
                            </li>
                            <li
                                onClick={() => {clickHandler("whats", true);tabClickHandler('/whats-news');}}
                                className={`subMenuLi ${insightTab === 'whats' && activeStateClass('whats-news') ? activeClass(isMobile) : ''}`}>
                                <div>
                                    <TabBox
                                        to="/whats-news"
                                        icon={'/images/navigation/navigation_whats-news_icon.svg'}
                                        lable={"What's New(s)"}
                                        isMobile={isMobile}
                                    />
                                </div>
                            </li>
                        </ul>

                    </li>
                    <li className={`${pathname === '/lets-talk' ? 'active' : ''}`}>
                        <Link onClick={() => clickHandler("/lets-talk")} to="/lets-talk" className={`nav-link letTalk ${isMobile ? (pathname === '/lets-talk' ? "active-letTalk-mobile" : "") : pathname === '/lets-talk' ? "active-letTalk-desktop" : ""} ${!isMobile ? 'd-letTalk' : ''}`}>
                            Let's talk
                        </Link>
                    </li>
                </ul>
            </>
        )
    }

    return (
        <>

            <OutsideClick arrowState={arrowState} isMobile={isMobile} handleOutsideClick={handleOutsideClick} />
            <ManageOverlay isSubmenuOpen={arrowState} winResize={winResize} />
            <div className='nav-fixed' onClick={() => handleClickOnNavArea()}>
                {isMB && isMobile ? <div onClick={() => isMB && mobileMenuHandler()}><Notification/></div>:<Notification/>}
                
                <nav className="navbar" onClick={() => handleClickOnNavArea()}>
                    <div className="navbar-container" ref={refContainer} style={{ width: refContainer }}>
                        <Link to="/" className="nav-logo" onClick={() => isMB && isMobile && mobileMenuHandler()}>
                            <BBYLogo.Dotlottie />
                        </Link>

                        {navFunction()}

                        <div
                            className="mobile-menu-icon"

                            onClick={mobileMenuHandler}
                        >
                            <div ref={hammberRef} className={`hamburger ${isMobile ? "active" : ""}`}>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                </nav >
            </div>

        </>

    )
}
function ManageOverlay({ isSubmenuOpen, winResize }) {
    const isMobile = useCheckMobileScreen();
    if (isMobile) {
        return <div />;
    }
    if (winResize) {
        return <div />;
    }
    return isSubmenuOpen ? <div className='overlay' /> : <div />;
}
export default MainHeader